import { Button, MenuItem, Paper, Select, Stack, Typography } from '@mui/material';
import React, { useState } from 'react';
import { useParams } from 'react-router';
import { useGeneratePasswordResetLinkMutation, useGetUsersQuery } from '../../../api/userSlice';
import CopyButton from '../../CustomComponents/CopyButton';

function PasswordReset() {
    const params = useParams();
    const [selectedUser, setSelectedUser] = useState();
    const [generatedLink, setGeneratedLink] = useState();

    const { 
        data: fetchedUsers = [],
    } = useGetUsersQuery({ hospitalId: params.hospitalId });

    const [generateLink] = useGeneratePasswordResetLinkMutation();

    async function handleGenerateLink() {
        await generateLink({
            user: selectedUser
        }).unwrap().then((payload) => {
            setGeneratedLink(payload.reset_link);
        });
    }

    return (
        <Paper elevation={2} sx={{ margin: '32px', width: '50%' }}>
            <Stack spacing={2} p={2}>
                <Typography variant='bold' sx={{ fontSize: '16px' }}>Create Password Reset for User</Typography>
                <Typography variant='normal' sx={{ fontSize: '14px' }}>Choose a User</Typography>
                <Select 
                    value={selectedUser}
                    onChange={(e) => setSelectedUser(e.target.value)}
                    sx={{ width: '100%' }}
                >
                    { fetchedUsers.map((user) => (
                        <MenuItem key={user.id} value={user}>{user.name}</MenuItem>
                    ))}
                </Select>
                <Button variant='text' onClick={handleGenerateLink} disabled={!selectedUser} sx={{ alignSelf: 'end' }}>
                    Generate Link
                </Button>
                { generatedLink &&
                    <Stack spacing={2} direction='row' alignItems='center'>
                        <CopyButton textToCopy={generatedLink} size='medium' fontSize='16px' />
                        <Typography noWrap variant='normal' sx={{ fontSize: '14px' }}>{generatedLink}</Typography>
                    </Stack>
                }
            </Stack>
        </Paper>
    );
}

export default PasswordReset;
